import { ApiService } from "./ApiService"

export class MitraService {

    static uri = '/agensi/mitra';

    static get({params}) {
        return ApiService.get(`${this.uri}`,{
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static update({ data, id }) {
        return ApiService.post(`${this.uri}/update/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`,{}, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}